import { defineMessages } from '@jutro/locale';

export default defineMessages({
    unableToReassign: {
        id: 'gateway.directives.reassign-activity.Unable to reassign',
        defaultMessage: 'Unable to reassign',
    }
});
